namespace GeniuzPOS.Product {
    export class PluDtColumns {
        static columnsKey = 'Product.PluDt';
    }
}
